import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { FeldUnterkategoriesQuerySorterConfig } from 'fa-kt.types';
import { FeldUnterkategoriesService } from '../service';

@Component({
  selector: 'fa-kt-feld-unterkategories-sorter',
  templateUrl: './feld-unterkategories-sorter.component.html',
  styleUrls: ['./feld-unterkategories-sorter.component.css'],
})
export class FeldUnterkategoriesSorterComponent {
  FeldUnterkategoriesSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public feldUnterkategories: FeldUnterkategoriesService,
  ) {
    this.FeldUnterkategoriesSorterConfig = FeldUnterkategoriesQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
